module.exports = __webpack_public_path__ + "static/media/VOC_icon.c7a7ff35.png";